<section class="autodiagnostico" *ngIf="page() === 'home'">
  <div class="autodiagnostico-wrapper">
    <div class="container-fluid h-100">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-lg-6 px-0 h-100">
          <div class="autodiagnostico-wrapper-mockup text-center d-flex">
            <div class="align-self-center">
              <h2 class="font-weight-bold mt-4">Bienvenido/a a <span class="mandatory">Madrid Aula Digital</span></h2>
              <img class="img-fluid" src="/assets/aula-madrid/landing_mockup.png" alt="Maqueta de dispositivos con la plataforma de Madrid Aula Digital">
            </div>
          </div>
        </div>
        <div class="col-lg-6 px-0 h-100">
          <div class="autodiagnostico-wrapper-selection d-flex">
            <div class="autodiagnostico-wrapper-selection-info align-self-center">
              <h6 class="autodiagnostico-wrapper-selection-info-text text-center text-white px-4 mb-4">Selecciona qué camino quieres seguir para personalizar tu experiencia en Madrid Aula Digital.</h6>
              <h6 class="autodiagnostico-wrapper-selection-info-text text-center text-white px-4">Te acompañamos en todo el proceso para que descubras  los más de 150 cursos disponibles para mejorar tus habilidades digitales.</h6>
              <div class="autodiagnostico-wrapper-selection-info-btns">
                <a routerLink="/">
                  <div class="autodiagnostico-wrapper-selection-info-btns-item d-flex flex-row flex-nowrap align-items-center justify-content-center">
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-text">
                      <h5 class="text-white">Directo al catálogo</h5>
                    </div>
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-link">
                      <h5 class="text-center text-white font-weight-bold">>></h5>
                    </div>
                  </div>
                </a>
                <a href="https://auladigital.comunidad.madrid/landing/registro.html">
                  <div class="autodiagnostico-wrapper-selection-info-btns-item d-flex flex-row flex-nowrap align-items-center justify-content-center">
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-text">
                      <h5 class="text-white">Registrarme en programa para la ciudadanía</h5>
                    </div>
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-link">
                      <h5 class="text-center text-white font-weight-bold">>></h5>
                    </div>
                  </div>
                </a>
                <a href="https://auladigital.comunidad.madrid/turismodigital/registro.html">
                  <div class="autodiagnostico-wrapper-selection-info-btns-item d-flex flex-row flex-nowrap align-items-center justify-content-center">
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-text">
                      <h5 class="text-white">Registrarme en programa de turismo digital</h5>
                    </div>
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-link">
                      <h5 class="text-center text-white font-weight-bold">>></h5>
                    </div>
                  </div>
                </a>
                <a routerLink="/aula-madrid/ayuda">
                  <div class="autodiagnostico-wrapper-selection-info-btns-item d-flex flex-row flex-nowrap align-items-center justify-content-center">
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-text">
                      <h5 class="text-white">Ayúdame a seguir</h5>
                    </div>
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-link">
                      <h5 class="text-center text-white font-weight-bold">>></h5>
                    </div>
                  </div>
                </a>
                <a routerLink="/aula-madrid/institucion">
                  <div class="autodiagnostico-wrapper-selection-info-btns-item d-flex flex-row flex-nowrap align-items-center justify-content-center">
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-text">
                      <h5 class="text-white">Soy una institución</h5>
                    </div>
                    <div class="autodiagnostico-wrapper-selection-info-btns-item-link">
                      <h5 class="text-center text-white font-weight-bold">>></h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="autodiagnostico" *ngIf="page() === 'ayuda'">
  <div class="autodiagnostico-wrapper">
    <div class="container-fluid h-100">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-lg-6 px-0 h-100">
          <div class="autodiagnostico-wrapper-mockup text-center d-flex">
            <div class="align-self-center">
              <h2 class="font-weight-bold mt-4">Bienvenido/a a <span class="mandatory">Madrid Aula Digital</span></h2>
              <img class="img-fluid" src="/assets/aula-madrid/landing_mockup.png" alt="Maqueta de dispositivos con la plataforma de Madrid Aula Digital">
            </div>
          </div>
        </div>
        <div class="col-lg-6 px-0 h-100">
          <div class="autodiagnostico-wrapper-selection d-flex">
            <div class="autodiagnostico-wrapper-selection-info align-self-center">
              <div class="autodiagnostico-wrapper-selection-info-follow text-white">
                <h3 class="text-center font-weight-bold">¿Necesitas ayuda para acceder<br>a <span class="mandatory font-italic">Madrid Aula Digital</span>?</h3>
                <p class="mt-4">Te lo ponemos fácil, contacta con un experto en la solución de la forma más sencilla para ti:</p>
                <ul>
                  <li>E-mail: <a class="font-weight-bold text-white" href="mailto:soporte@madridauladigital.org">soporte@madridauladigital.org</a></li>
                  <li>Teléfono:  900 42 32 70</li>
                  <li>WhatsApp:  911 23 82 65</li>
                </ul>
                <p class="mt-4">El horario de atención es:</p>
                <ul>
                  <li>Lunes – Viernes de 9:00 a 14:00 y de 17:00 a 20:00</li>
                  <li>Sábados de 10:00 a 14:00</li>
                </ul>
                <h5 class="font-weight-bold text-center mt-4">Descubre los más de 150 cursos disponibles para mejorar tus habilidades digitales</h5>
              </div>
              <div class="mt-5 text-center botones-acciones">
                <a routerLink="/aula-madrid" class="btn-prim-light">Volver</a>
                <a routerLink="/" class="btn-prim-light">Continuar</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="autodiagnostico" *ngIf="page() === 'institucion'">
  <div class="autodiagnostico-wrapper">
    <div class="container-fluid h-100">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-lg-6 px-0 h-100">
          <div class="autodiagnostico-wrapper-mockup text-center d-flex">
            <div class="align-self-center">
              <h2 class="font-weight-bold mt-4">Bienvenido/a a <span class="mandatory">Madrid Aula Digital</span></h2>
              <img class="img-fluid" src="/assets/aula-madrid/landing_mockup.png" alt="Maqueta de dispositivos con la plataforma de Madrid Aula Digital">
            </div>
          </div>
        </div>
        <div class="col-lg-6 px-0 h-100">
          <div class="autodiagnostico-wrapper-selection d-flex">
            <div class="autodiagnostico-wrapper-selection-info align-self-center">
              <div class="autodiagnostico-wrapper-selection-info-follow text-white">
                <h3 class="text-center font-weight-bold">¿Eres un ayuntamiento, centro público, ONG u otra asociación?</h3>
                <p class="mt-4 text-center">Organizamos sesiones de formación presencial en tu centro. Pensadas para el ciudadano y totalmente gratuitas.</p>
                <p class="mt-4 text-center">Para más información, puedes contactar con:</p>
                <p class="text-center font-weight-bold"><a class="text-white" href="mailto:instituciones@madridauladigital.org">instituciones@madridauladigital.org</a></p>
              </div>
              <div class="mt-5 text-center botones-acciones">
                <a routerLink="/aula-madrid" class="btn-prim-light">Volver</a>
                <a routerLink="/" class="btn-prim-light">Continuar</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
